
import { mapMutations } from 'vuex'; 
import { Swiper, Navigation } from "swiper";
import ArticleCardStyleme from './ArticleCardStyleme.vue';

export default {
    name: "styleme-article",
    components: { ArticleCardStyleme },
    data() {
        return {
            swiper: '',
            showAnimation: false,
            pa_count: 1,
            item: {
                id: 1, 
                params: { 
                    per_page: 10 
                }
            },
            link_text: "https://styleme.pixnet.net/topics",
            link_name: "焦點話題",
            api_id_arr: [1, 4, 7, 13, 16],
            api_link_arr: [
                "https://styleme.pixnet.net/topics",
                "https://styleme.pixnet.net/skincare",
                "https://styleme.pixnet.net/beautytips",
                "https://styleme.pixnet.net/fashion",
                "https://styleme.pixnet.net/life"
            ],
            api_name_arr : [
                "焦點話題", "保養", "美妝", "時尚", "生活"
            ]
        };
    },
    computed: {
        article_data() {
            return this.$store.state.styleme.article_data;
        },
        tab_id() {
            return this.$store.state.styleme.tab_id;
        },
        tab_left() {
            return this.$store.state.styleme.tab_highlight_style.left;
        },
        tab_width() {
            return this.$store.state.styleme.tab_highlight_style.width;
        },
        window_width() {
            return this.$store.state.styleme.window_width;
        }
    },
    methods: {
        ...mapMutations('styleme', [
            'updateTabId',
            'updateTabLeft',
            'updateTabWidth',
            'updateWindowWidth'
        ]),
        async activeTab(id) {
            if (this.tab_id != id) {
                this.setTabHighLighter(id, this.tab_id);
                this.item.id = this.api_id_arr[id - 1];
                this.link_text = this.api_link_arr[id - 1];
                this.link_name = this.api_name_arr[id - 1];
                await this.$store.dispatch("styleme/getArticleData", this.item);
            }
        },
        countTabLeft() {
            return this.$refs.styleme_tab.getBoundingClientRect().left;
        },
        initTabHighLighter(id) {
            const width = this.$refs.styleme_tab.children[id - 1].clientWidth;
            const left = this.$refs.styleme_tab.children[id - 1].getBoundingClientRect().left;
            const tab_left = this.countTabLeft();
            this.updateTabLeft(left - tab_left);
            this.updateTabWidth(width);
        },
        resizeTabHighLighter(id) {
            setTimeout(() => {
                if (this.$refs.styleme_tab.children[id - 1] != undefined) {
                    const width = this.$refs.styleme_tab.children[id - 1].clientWidth;
                    const left = this.$refs.styleme_tab.children[id - 1].getBoundingClientRect().left;
                    const tab_left = this.countTabLeft();
                    this.updateTabLeft(left - tab_left);
                    this.updateTabWidth(width);
                }
            }, 100);
        },
        setTabHighLighter(id, origin_id) {
            const active_img_width = 27;
            const width = this.$refs.styleme_tab.children[id - 1].clientWidth;
            const left = this.$refs.styleme_tab.children[id - 1].getBoundingClientRect().left;
            const tab_left = this.countTabLeft();
            if (id == 1 || id < origin_id) {
                this.updateTabLeft(left - tab_left);
            }
            else {
                this.updateTabLeft(left - tab_left - active_img_width);
            }
            this.updateTabWidth(width + active_img_width);
            this.updateTabId(id);
        },
        setShowAnimation() {
            setTimeout(() => {
                this.showAnimation = true;
            }, 500);
        },
        setWindowWidth() {
            this.updateWindowWidth(window.innerWidth);
        },
        replaceTabWhenResizeWindow() {
            if (this.tab_id > 2 && this.window_width > 1024) {
                this.activeTab(1);
            }
        },
        executeWhenResize(e) {
            this.setWindowWidth();
            this.replaceTabWhenResizeWindow();
            this.resizeTabHighLighter(this.tab_id);
        }
    },
    async fetch() {
        await this.$store.dispatch("styleme/getArticleData", this.item);
    },
    mounted() {
        window.addEventListener("resize", this.executeWhenResize);
        this.initTabHighLighter(this.tab_id);
        this.setShowAnimation();
        this.setWindowWidth();
        this.countTabLeft();

        Swiper.use([Navigation]);
        this.swiper = new Swiper(".hot-styleme-swiper", {
            direction: "horizontal",
            breakpoints: {
                769: {
                    slidesPerView: 3,
                    spaceBetween: 16
                }
            },
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 8,
            observer: true,
            modules: [Navigation],
        });
    },
}
